import "./Header.styles.css";

export function Header() {
  return (
    <header className="header">
      <h1>Gabriel Dario Dev</h1>

      <nav>
        <a href="#">Login in</a>
        <a href="#">Know about me</a>
      </nav>
    </header>
  );
}